import { Component } from '@angular/core';
import { AppFrameService } from '@herrenknecht-connected/angular-shared-feature-app-frame';

@Component({
  selector: 'hk-status-root',
  templateUrl: './status-ui.component.html',
  host: { class: 'h-full w-full flex flex-col' },
})
export class StatusComponent {
  embedded = false;

  constructor(
    protected appFrame: AppFrameService) {  }
}
